export default __webpack_public_path__ + "static/media/CAMIONETA_DE_POLICIA.b5fc60b1.jpg";